const inviteUploaderForm = {
  toggleButton: "+ Bjóða nýjum gagnahleðara með tölvupósti",
  heading: "Bjóða nýjum gagnahleðara",
  successMessage: "Boð sent á {{email}} fyrir {{org}}",
  selectedOrgFallback: "valda stofnun",
  organizationPlaceholder: "-- Veldu stofnun --",
  addNewOrganizationOption: "+ Bæta við nýrri stofnun...",
  newOrgNamePlaceholder: "Nafn nýrrar stofnunar (t.d. Landspítali)",
  emailPlaceholder: "gagnahledari@sjukrahus.is",
  sendButton: "Senda boð",
  sending: "Sendi...",
  alerts: {
    invalidEmail: "Vinsamlegast sláðu inn gilt netfang",
    selectOrganization: "Vinsamlegast veldu stofnun",
    enterNewOrgName: "Vinsamlegast sláðu inn nafn nýju stofnunarinnar",
    sendFailed: "Ekki tókst að senda boð",
  },
};

export default inviteUploaderForm;
